import jwtDecode from "jwt-decode";
import { setCurrentUser } from "@/redux/user.reducer";
import { apiEndpoints } from "@/utils/api-endpoints";
import { buildUserFromToken } from "@/lib/build-user-from-token";
import {forceLogout} from "@/utils/force-logout";

let refreshTimeout: ReturnType<typeof setTimeout> | null = null;

export const scheduleTokenRefresh = (user: any, dispatch: any, getState: any) => {
    if (!user?.jwtToken) return;

    clearTokenRefresh();

    let decoded;
    try {
        decoded = jwtDecode(user.jwtToken);
    } catch {
        return;
    }

    const refreshTime = decoded.exp * 1000 - Date.now() - 2 * 60 * 1000;
    if (refreshTime <= 0) return;

    refreshTimeout = setTimeout(async () => {
        const state = getState();
        if (!state.user.currentUser) return;

        try {
            const res = await fetch(apiEndpoints.User.RefreshToken.url, {
                method: apiEndpoints.User.RefreshToken.method,
                credentials: "include",
            });

            const json = await res.json();

            if (json?.data?.jwtToken) {
                dispatch(setCurrentUser(buildUserFromToken(json.data.jwtToken, user)));
            }
        } catch {
            forceLogout(dispatch);

        }
    }, refreshTime);
};


export const clearTokenRefresh = () => {
    if (refreshTimeout) {
        clearTimeout(refreshTimeout);
        refreshTimeout = null;
    }
};